import { render, staticRenderFns } from "./PotentialPoliciesTable.vue?vue&type=template&id=2c7bfd99&scoped=true&"
import script from "./PotentialPoliciesTable.vue?vue&type=script&lang=js&"
export * from "./PotentialPoliciesTable.vue?vue&type=script&lang=js&"
import style0 from "./PotentialPoliciesTable.vue?vue&type=style&index=0&id=2c7bfd99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7bfd99",
  null
  
)

export default component.exports